import { createContext, PropsWithChildren, useCallback } from 'react'
import { useAppSelector, useAppDispatch } from '~/store/hooks'
import { updateRoofSection } from '~/store/objects'
import { RoofSection } from '~/store/objects/types'
import { mostRecentSelectedObjectOfClassName } from '~/store/selectedObjects/selectors'
import CLASS_NAMES from 'config/objectClassNames'

type SelectedRoofSectionContextValue = {
  selectedRoofSection: RoofSection
  handleUpdate: (updatedRoofSection: Partial<RoofSection>) => void
}

export const SelectedRoofSectionContext = createContext<SelectedRoofSectionContextValue | null>(null)

export const SelectedRoofSectionProvider = ({ children }: PropsWithChildren) => {
  const selectedRoofSection = useAppSelector(({ selectedObjects, objects }) =>
    mostRecentSelectedObjectOfClassName(CLASS_NAMES.ROOF_SECTION, { selectedObjects, objects })
  )
  const dispatch = useAppDispatch()
  const handleUpdate = useCallback(
    (updatedRoofSection: Partial<RoofSection>) => {
      if (selectedRoofSection)
        dispatch(updateRoofSection({ roofSection: { ...selectedRoofSection, ...updatedRoofSection } }))
    },
    [dispatch, selectedRoofSection]
  )

  if (!selectedRoofSection) return null

  return (
    <SelectedRoofSectionContext.Provider value={{ selectedRoofSection, handleUpdate }}>
      {children}
    </SelectedRoofSectionContext.Provider>
  )
}
